import { render } from "./IdleModal.vue?vue&type=template&id=55aad5a8"
import script from "./IdleModal.vue?vue&type=script&lang=js"
export * from "./IdleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__